import React, { useEffect, useRef, useState } from 'react';
import { Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { GoogleMap, Circle } from "@react-google-maps/api";
import { googleMapLoader } from '../../../helpers/googleMapLoader';
import cx from 'classnames';

import messages from '../../../locale/messages';
import { DARK_SECONDARY_COLOR, SECONDARY_COLOR } from '../../../constants'
import { mapThemeStyle } from '../../../helpers/mapThemeStyle';
import s from './LocationMap.css';

const containerStyle = {
  width: '100%',
  height: '100%'
};
const LocationMap = ({ data }) => {

  const theme = useSelector(state => state.currency.theme);
  const googleMapBrowserApiKey = useSelector(state => state?.encodeConfigSettings?.googleMapBrowserApiKey);
  const prevTheme = useRef(theme);
  const mapCircleBg = theme === 'dark' ? DARK_SECONDARY_COLOR : SECONDARY_COLOR;

  const [center, setCenter] = useState({});
  const [markers, setMarkers] = useState(null);
  const [googleMapsApiLoaded, setGoogleMapsApiLoaded] = useState(false);
  const [styles, setStyles] = useState([
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{
        color: '#a4ddf5'
      }]
    }
  ]);

  useEffect(() => {
    const initialize = async () => {
      setStyles(mapThemeStyle(theme));
      await googleMapLoader(googleMapBrowserApiKey);
      setGoogleMapsApiLoaded(true);
      if (theme !== prevTheme) {
        setStyles(mapThemeStyle(theme));
      }

      const lat = Number(data.lat);
      const lng = Number(data.lng);

      setCenter({ lat, lng });
    };

    initialize();
  }, []);

  const handleOnLoad = (map) => {
    const markers = [{
      position: new google.maps.LatLng(center.lat, center.lng)
    }];
    const bounds = new google.maps.LatLngBounds();
    markers.forEach(({ position }) => bounds.extend(position));
    map.fitBounds(bounds);
  };


  let firstName, city, country;
  firstName = data.user.profile.firstName;
  city = data.city;
  country = data.country;

  return (
    <Row className={cx(s.pageContent, 'viewListingMap')} >
      <div className={cx(s.space2, s.horizontalLineThrough)}>
        <h1 className={cx(s.sectionTitleText, s.space2)}><FormattedMessage {...messages.neighborhood} /></h1>
      </div>
      <div className={cx(s.space2)}>
        <div className={cx(s.locationNameCss)}>{firstName}{' '}<FormattedMessage {...messages.propertyLocated} />{' '}{city}, {country}</div>
        <div style={{ height: 350 }} className='viewListingMapResultContainer'>
          {
            googleMapsApiLoaded ?
              <GoogleMap
                mapContainerStyle={containerStyle}
                defaultZoom={10}
                center={center}
                onLoad={handleOnLoad}
                clickableIcons={false}
                options={{
                  backgroundColor: '',
                  scrollwheel: false,
                  maxZoom: 16,
                  minZoom: 10,
                  borderRadius: '15px',
                  streetViewControl: false,
                  zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_TOP
                  },
                  mapTypeControl: false,
                  styles: styles
                }}
              >
                <Circle
                  center={center}
                  radius={200}
                  options={{
                    fillColor: mapCircleBg,
                    strokeColor: mapCircleBg
                  }}
                />
              </GoogleMap>
              :
              <></>
          }
        </div>
        <div className={cx(s.locationSmallText)}><FormattedMessage {...messages.neighborhoodInfo} /></div>
        <div className={s.listingLine}></div>
      </div>
    </Row>
  );
}

LocationMap.propTypes = {
  data: PropTypes.object,
  formatMessage: PropTypes.any,
};

export default withStyles(s)(LocationMap);
